import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import PrivateRoute from './components/PrivateRoute';

import Login          from './pages/Login';
import Dashboard      from './pages/Dashboard';
import Contas         from './pages/Contas';
import Cartoes        from './pages/Cartoes';
import Transacoes     from './pages/Transacoes';
import Transferencias from './pages/Transferencias';
import Categorias     from './pages/Categorias';
import Orcamentos     from './pages/Orcamentos';
import Metas          from './pages/Metas';
import Recorrencias   from './pages/Recorrencias';
import Relatorios     from './pages/Relatorios';
import Extrato        from './pages/Extrato';
import SubUsuarios    from './pages/SubUsuarios';
import Perfil         from './pages/Perfil';

function Private({ children }) {
  return <PrivateRoute>{children}</PrivateRoute>;
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/"               element={<Private><Dashboard /></Private>} />
          <Route path="/contas"         element={<Private><Contas /></Private>} />
          <Route path="/cartoes"        element={<Private><Cartoes /></Private>} />
          <Route path="/transacoes"     element={<Private><Transacoes /></Private>} />
          <Route path="/transferencias" element={<Private><Transferencias /></Private>} />
          <Route path="/categorias"     element={<Private><Categorias /></Private>} />
          <Route path="/orcamentos"     element={<Private><Orcamentos /></Private>} />
          <Route path="/metas"          element={<Private><Metas /></Private>} />
          <Route path="/recorrencias"   element={<Private><Recorrencias /></Private>} />
          <Route path="/relatorios"     element={<Private><Relatorios /></Private>} />
          <Route path="/extrato"        element={<Private><Extrato /></Private>} />
          <Route path="/sub-usuarios"   element={<Private><SubUsuarios /></Private>} />
          <Route path="/perfil"         element={<Private><Perfil /></Private>} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}
